import React, { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { StyledTag, StyledAndTag, StyledOrTag } from './styled';
import { getRuleId } from '@utils/filter/ruleUtils';

const AndTag = () => <StyledAndTag color="geekblue">AND</StyledAndTag>;
const OrTag = () => <StyledOrTag color="cyan">OR</StyledOrTag>;

function FilterBar({ rules, removeRule }) {
  const dispatch = useDispatch();

  const handleCloseFn = (rule) => () => {
    dispatch(removeRule(rule));
  };

  const ruleTag = (rule) => {
    return (
      <StyledTag key={getRuleId(rule)} color="blue" closable onClose={handleCloseFn(rule)}>
        {rule.display}
      </StyledTag>
    );
  };

  const buildAndRule = (andRule) => {
    const orRules = andRule.map((orRule) => ruleTag(orRule));
    return orRules.reduce((acc, ele, idx) => [acc, <OrTag key={idx} />, ele]);
  };

  const buildRuleFragements = (rules) => {
    const andrules = rules.map((andRule) => buildAndRule(andRule));
    return andrules.reduce((acc, ele, idx) => [acc, <AndTag key={idx} />, ele]);
  };

  const ruleFragments = useMemo(() => buildRuleFragements(rules), [rules]);

  return <div>{ruleFragments}</div>;
}

export default FilterBar;
